import React, { useState } from "react";
import {
    getAuth,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
} from "firebase/auth";
import firebaseApp from "../index";

const Logueo = () => {
    const auth = getAuth(firebaseApp);
    const [estaRegistrandose, setEstaRegistrandose] = useState(false);

    async function submitHandler(e) {
        e.preventDefault();
        const correo = e.target.fullname.value;
        const password = e.target.password.value;
        if (estaRegistrandose) {
            await createUserWithEmailAndPassword(auth, correo, password);
        } else {
            signInWithEmailAndPassword(auth, correo, password);
        }
    }
    return (
        <div>
            <section className="text-blue-900 body-font">
                <div className="container px-5 py-24 mx-auto flex flex-wrap items-center">
                    <div className="lg:w-3/5 md:w-1/2 md:pr-16 lg:pr-0 pr-0">
                        <img
                            alt="logo"
                            src="https://firebasestorage.googleapis.com/v0/b/calificapp-5883e.appspot.com/o/logos%2Flogo_textoblanco.svg?alt=media&token=40de069f-c381-4090-9d8d-6f8c8d0304a1"
                        ></img>
                    </div>
                    <div className="lg:w-2/6 md:w-1/2 bg-gray-800 rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 text-white">
                        {estaRegistrandose ? (
                            <h2 className=" text-2xl text-center title-font mb-5 text-white">
                                Registrarse
                            </h2>
                        ) : (
                            <h2 className=" text-2xl text-center title-font mb-5 text-white">
                                Ingresar
                            </h2>
                        )}
                        <form onSubmit={submitHandler}>
                            <div className="relative mb-4">
                                <label
                                    for="fullname"
                                    className="leading-7 text-sm text-white"
                                >
                                    E-mail
                                </label>
                                <input
                                    required
                                    type="email"
                                    id="fullname"
                                    name="fullname"
                                    className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                                />
                            </div>
                            <div className="relative mb-4">
                                <label
                                    for="password"
                                    className="leading-7 text-sm text-white"
                                >
                                    Password
                                </label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                                />
                            </div>

                            {estaRegistrandose ? (
                                <button className="text-white mt-2 bg-indigo-500 border-0 py-2 w-full focus:outline-none hover:bg-indigo-600 rounded text-lg">
                                    Registrarme
                                </button>
                            ) : (
                                <button className="text-white mt-2 bg-indigo-500 border-0 py-2 w-full focus:outline-none hover:bg-indigo-600 rounded text-lg">
                                    Iniciar Sesion
                                </button>
                            )}

                            {estaRegistrandose ? (
                                <div>
                                    <p className="text-lg text-white mt-3">
                                        ya tienes cuenta?{" "}
                                    </p>
                                    <button
                                        onClick={() =>
                                            setEstaRegistrandose(false)
                                        }
                                        className="text-white mt-2 bg-indigo-500 border-0 py-2 w-full focus:outline-none hover:bg-indigo-600 rounded text-lg"
                                    >
                                        Inicia Sesion
                                    </button>
                                </div>
                            ) : (
                                <div>
                                    <p className="text-lg text-white mt-3">
                                        Aun no tienes cuenta?{" "}
                                    </p>
                                    <button
                                        onClick={() =>
                                            setEstaRegistrandose(true)
                                        }
                                        className="text-white mt-2 bg-indigo-500 border-0 py-2 w-full focus:outline-none hover:bg-indigo-600 rounded text-lg"
                                    >
                                        Regístrate gratis!
                                    </button>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Logueo;
